/*
 * This is a custom version of the PageTitle widget. See ../config.js for how to get this to replace the standard one.
 */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    titleColor = "titleColor",
    borderWidth = "borderWidth",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.titleColor]: string;
        [fields.borderWidth]: string;
    };
}

export interface PageTitleStyles {
    mainContainer: InjectableCss;
    rightContainer: InjectableCss;
}

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, id, fields }) => {
    const pageTitleStyles: PageTitleStyles = {
        mainContainer: {
            css: css`
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: ${fields.titleColor};
                border-bottom: ${fields.borderWidth}px solid ${fields.titleColor};
            `,
        },
        rightContainer: {
            css: css`
                flex-basis: 25%;
            `,
        },
    };
    const styles = pageTitleStyles;
    return (
        <StyledWrapper {...styles.mainContainer}>
            <Typography variant="h3">{pageTitle}</Typography>
            <StyledWrapper {...styles.rightContainer}>
                <Zone contentId={id} zoneName="Content" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.titleColor,
                editorTemplate: "ColorPickerField",
                displayName: "titleColor",
                defaultValue: "#046faf",
            },
            {
                fieldType: "General",
                name: fields.borderWidth,
                editorTemplate: "TextField",
                displayName: "Border Width (px)",
                defaultValue: "4",
            },
        ],
    },
};

export default widgetModule;
